const React = require("react");

class DownloadLibrary extends React.Component {

    constructor() {
        super();

        this.state = {hasVendorImport: false, importAvailable: false};

        this.toggleShow = this.toggleShow.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.downloadLink = this.downloadLink.bind(this);
    }
    shouldComponentUpdate(nextProps, nextState){
        return this.props.importAvailable !== nextProps.importAvailable ||
            this.props.hasVendorImport !== nextProps.hasVendorImport;
    }

    toggleShow(addListen = false){
        this.hideSiblings(false);
        this.divShow.classList.toggle("show");
        this.headedShow.classList.toggle("show");
    }

    onBlur(event) {
        this.hideSiblings();
    }

    hideSiblings(hideAll=true){
        let items = document.querySelectorAll(".download.show, .download .show");
        for (let item of items) {
            if (hideAll || ![this.divShow, this.headedShow].includes(item)) item.classList.remove("show")
        }
    }

    downloadLink(link){
        this.hideSiblings();
        let a = document.createElement("a");
        a.href = link;
        document.body.appendChild(a);
        a.click();
        setTimeout(() => {document.body.removeChild(a);}, 0);
    }

    render() {
        return <span className={`download`} onBlur={this.onBlur}>
                    <span className={`download options list`}>
                        { !this.props.importAvailable && <span className="download__tooltip">Download LBR</span> }
                        <button className="button" onClick={ () => this.props.hasVendorImport ? this.toggleShow()
                                                                           : this.downloadLink(this.props.downloadOriginalUrl) }
                                ref={div => this.headedShow = div}>
                            { !this.props.importAvailable &&
                                 <svg width="14px" height="18px" viewBox="0 0 14 18">
                                    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd"
                                       transform="translate(-448.000000, -26.000000)">
                                        <g transform="translate(440.000000, 20.000000)" fill="#0696D7">
                                            <g transform="translate(8.000000, 6.000000)">
                                                <path
                                                    d="M9.3505553,9.477 L8.0275553,9.475 L8.0275553,6.475 C8.0275553,6.212 7.8145553,6 7.5525553,6 L6.5025553,6 C6.2405553,6 6.0275553,6.212 6.0275553,6.475 L6.0275553,9.475 L4.7065553,9.477 C4.5045553,9.477 4.4395553,9.647 4.5615553,9.854 L6.7825553,12.475 C6.9055553,12.683 7.1075553,12.684 7.2315553,12.477 L9.4925553,9.852 C9.6165553,9.646 9.5525553,9.477 9.3505553,9.477 L9.3505553,9.477 Z"></path>
                                                <polygon points="14 5 9 5 9 0 10 0 10 4 14 4"></polygon>
                                                <path
                                                    d="M10,0 L2,0 C0.896,0 0,0.895 0,2 L0,16 C0,17.105 0.896,18 2,18 L12,18 C13.104,18 14,17.105 14,16 L14,4 L10,0 L10,0 Z M13,16 C13,16.551 12.552,17 12,17 L2,17 C1.448,17 1,16.551 1,16 L1,2 C1,1.449 1.448,1 2,1 L9.586,1 L13,4.414 L13,16 L13,16 Z"></path>
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                            }
                            { this.props.importAvailable &&
                                <svg width="12px" height="8px" viewBox="0 0 12 8">
                                    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(-466.000000, -144.000000)">
                                        <g transform="translate(440.000000, 20.000000)" fill="#000000" fillRule="nonzero">
                                            <g transform="translate(25.959508, 123.776002)">
                                                <polygon points="0.5 1.90107267 1.75866667 0.566406 6.166 5.238406 10.5726667 0.566406 11.832 1.90107267 6.166 7.908406"></polygon>
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                            }
                        </button>
                        { this.props.hasVendorImport && this.downloadOptions() }
                    </span>
               </span>
    }

    downloadOptions() {
        return <span className={`download__container download__container dropdown`} ref={div => this.divShow = div}>
                    <a className="dropdown-item" onMouseDown={() => this.downloadLink(this.props.downloadOriginalUrl)}>
                        Download original file
                    </a>
                    <a className={`dropdown-item ${this.props.importAvailable ? "" : "disable" }`}
                       onMouseDown={() => this.props.importAvailable && this.downloadLink(this.props.downloadConvertedUrl)}>
                        {
                            this.props.importAvailable ? "Download imported library"
                                                       : "Import running, please wait..."
                        }
                    </a>
               </span>
    }
}

module.exports = DownloadLibrary;
